import React from "react";
import "./Avatar.css";

interface AvatarProps {
    url?: string;
    alt?: string;
    size?: "small" | "medium" | "large";
}

const Avatar: React.FC<AvatarProps> = ({ url, alt = "Avatar", size = "small" }) => {
    if (!url) {
        return null;
    }

    return (
        <img 
            src={url} 
            alt={alt} 
            className={`Avatar Avatar--${size}`}
        />
    );
};

export default Avatar;
